


























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import imageApi from '@/app/model/api/getImageApi'

@Component({
  components: {
    Loading
  }
})
export default class GraphImageModal extends Vue {
  @Prop() private imgPath!: string
  @Prop() private imgAlt!: string

  private closeModal () {
    this.$emit('close-modal')
  }
}
